import React from 'react';
/**
 * Created by alvinoktavianus (https://github.com/alvinoktavianus)
 * on 02/04/18
 */

import { PAYMENT_METHOD_KEY } from 'utils/paymentMethodConstants';
import Ovo from './Ovo';
import GoPay from './GoPay/GoPay';
import TCash from './TCash';
import AkuLaku from './AkuLaku';
import Kredivo from './Kredivo';
import Dana from './Dana';
import Alto from './Alto';

const TermsAndConditionsBody = props => {
  switch (props.paymentMethodCode) {
    case PAYMENT_METHOD_KEY.OVO:
      return <Ovo language={props.language} />;
    case PAYMENT_METHOD_KEY.GOPAY:
      return <GoPay language={props.language} />;
    case PAYMENT_METHOD_KEY.TCASH:
      return <TCash language={props.language} />;
    case PAYMENT_METHOD_KEY.AKULAKU:
      return <AkuLaku language={props.language} />;
    case PAYMENT_METHOD_KEY.KREDIVO:
      return <Kredivo language={props.language} />;
    case PAYMENT_METHOD_KEY.DANA:
      return <Dana language={props.language} />;
    case PAYMENT_METHOD_KEY.ALIPAY:
    case PAYMENT_METHOD_KEY.WECHATPAY:
      return <Alto language={props.language} />;
  }
};

export default TermsAndConditionsBody;
